<template>
  <v-container grid-size-md>
    <v-layout justify-center>
      <v-flex xs12 lg8>
        <v-form v-model="valid" ref="form">
          <v-card>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    prepend-inner-icon="mdi-format-title"
                    label="Título"
                    v-model="comunicado.titulo"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="comunicado.idTurmas"
                    :disabled="turmas.length < 1 || comunicado.id != null"
                    :items="turmas"
                    label="Turma"
                    :item-text="
                      turma =>
                        `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
                    "
                    multiple
                    chips
                    item-value="id"
                    hint="Seleciona a(s) Turma(s)"
                    persistent-hint
                    required
                    :rules="rules"
                  ></v-select>
                </v-flex>

                <v-flex xs12 class="mt-4">
                  <p class="title primary--text">Notificar para</p>
                  <v-radio-group
                    row
                    v-model="comunicado.enviar"
                    required
                    :rules="rules"
                  >
                    <v-radio
                      v-for="(option, index) in radioOptions"
                      :key="option"
                      color="primary"
                      :label="option"
                      :value="String(index)"
                    />
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-row>
                    <v-col>
                      <p class="title primary--text">Descrição do evento</p>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        color="primary"
                        @click="$refs.upload.click()"
                      >
                        <v-icon class="mr-3">mdi-paperclip</v-icon>Anexar
                        Arquivo
                      </v-btn>
                      <input
                        type="file"
                        ref="upload"
                        multiple
                        v-show="false"
                        @change="handleUpload"
                      />
                    </v-col>
                    <v-col class="text-left">
                      <v-btn color="primary" @click="$refs.uploadPhoto.click()">
                        <v-icon class="mr-3">mdi-camera</v-icon>Enviar Capa
                      </v-btn>
                      <input
                        type="file"
                        ref="uploadPhoto"
                        v-show="false"
                        @change="handlerPhoto()"
                      />
                    </v-col>
                  </v-row>
                  <wysiwyg v-model="comunicado.descricao" />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" dark @click="submit">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snack.hide"
      bottom
      :color="snack.color"
      :timeout="snack.imeout"
      multi-line
      >{{ this.snack.mensage }}</v-snackbar
    >
  </v-container>
</template>

<script>
import { Turma, Comunicado } from '../../service'

export default {
  data() {
    return {
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      turmas: [],
      snack: {},
      menu: false,
      radioOptions: ['Aluno', 'Responsável', 'Ambos'],
      files: [],
      capa: [],
      comunicado: {
        idTurmas: null,
        status: 'C'
      },
      valid: true,
      rules: [v => !!v || 'Campo requerido.']
    }
  },
  async created() {
    this.turmas = await Turma.findAll({ escola: this.escola })
    if (this.$route.params.id) {
      const comunicado = await Comunicado.findById(this.$route.params.id, {
        escola: this.escola
      })
      this.comunicado = comunicado
      this.comunicado.idTurmas = comunicado.turma.map(turma => turma.id)
    }
  },
  methods: {
    async submit() {
      if (await this.$refs.form.validate()) {
        if (this.comunicado.descricao) {
          this.comunicado = await Comunicado.save(this.comunicado, {
            escola: this.escola
          })

          await Comunicado.setAnexos(
            this.comunicado.id,
            this.files,
            this.escola
          )
          await Comunicado.setCapa(this.comunicado.id, this.capa, this.escola)
          this.snack = {
            mensage: 'Comunicado com sucesso!',
            icon: 'far fa-check-circle',
            hide: true,
            timeout: 3000
          }
          this.$router.push(`/comunicados/${this.comunicado.id}`)
        } else {
          this.snack = {
            mensage: 'O campo descrição também é obrigatório.',
            icon: 'far fa-check-circle',
            hide: true,
            timeout: 3000,
            color: 'red'
          }
        }
      }

      //alert('Criou')
    },
    handleUpload() {
      this.files = this.$refs.upload.files
    },
    handlerPhoto() {
      this.capa = this.$refs.uploadPhoto.files[0]
    }
  }
}
</script>

<style scoped>
.img-preview {
  max-height: 400px;
  max-width: 800px;
}
</style>
